import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { AlternatingRowsWrapper } from "./AlternatingRows.styles"
import {
  StatamicHtml,
  prefixStatamicAssetUrl,
} from "../../../utils/statamicAssets"

const AlternatingRows = ({ rowData, rowAlternation }) => {
  const title = rowData.title
  const backgroundColor =
    rowData.row_background_colour && rowData.row_background_colour.value
  const description = rowData.description
  const image = rowData.image

  let bgColor = "bg-row-green"
  let textColor = "row-text-white"
  let padding1 = "pr-lg-5"
  let padding2 = "pl-lg-0"
  let flexDirection = ""

  if (backgroundColor === "Blue") {
    bgColor = "bg-row-blue"
  }
  if (backgroundColor === "White") {
    textColor = "text-dark-green"
    bgColor = "bg-row-white"
  }
  if (backgroundColor === "Grey") {
    textColor = "text-dark-green"
    bgColor = "bg-row-grey"
  }

  if (rowAlternation === "even") {
    padding1 = "pl-lg-5"
    padding2 = "pr-lg-0"
    flexDirection = "flex-row-reverse"
  }

  const imageUrl =
    image && prefixStatamicAssetUrl(image.permalink || image.url)
  const imageAlt = (image && image.alt) || title || ""

  let imageContainer
  let copyContentColCount = 12

  if (imageUrl) {
    imageContainer = (
      <Col lg={4} md={8} className={padding2 + " m-auto"}>
        <img
          src={imageUrl}
          alt={imageAlt}
          width={image && image.width}
          height={image && image.height}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Col>
    )
    copyContentColCount = 8
  }

  return (
    <AlternatingRowsWrapper className={"py-5 px-4 px-sm-5 " + bgColor}>
      <Container className="py-5 px-0">
        <Row
          className={
            textColor +
            " text-lg-left text-md-center text-left justify-content-center " +
            flexDirection
          }
        >
          <Col lg={copyContentColCount} className={"" + padding1}>
            <h2 className="h1 font-weight-bold mb-4 secondary-blue-2-text nunito">
              {title}
            </h2>
            <StatamicHtml html={description} />
          </Col>
          {imageContainer}
        </Row>
      </Container>
    </AlternatingRowsWrapper>
  )
}

export default AlternatingRows
